export const environment = {
	production: true,
	enableKioskOnResume: false,
	baseUrl: "https://api.stg01.hxa.io",
};
